import React, {Component} from "react";

import {LeftOutlined, RightOutlined} from "@ant-design/icons";
import {Button, Layout, Menu} from "antd";

import api from "../../api";
import * as Auth from "../../AuthService";
import {DashboardHeader} from "../../components/header/DashboardHeader";

import "./ProjectLayout.css";

export class ProjectLayout extends Component {
	constructor(props) {
		super(props);
		this.state = {
			_id: "",
			openKeys: [],
			navigation: [],
			baseUrl: "",
			collapsed: false,
		};
	}

	getMenuItems() {
		const items = [];
		for (const element of this.state.navigation) {
			if (element.children.length > 0) {
				const url = element.link.startsWith("/") && this.state.baseUrl + this.state._id + element.link;
				items.push(
					<Menu.SubMenu
						style={{marginLeft: 0, color: "black"}}
						className={url === this.props.location.pathname && "ant-menu-item-selected"}
						title={
							!element.link.startsWith("/") ? (
								element.name
							) : (
								<a style={{color: "black"}} href={this.state.baseUrl + this.state._id + element.link}>
									{element.name}
								</a>
							)
						}
						key={element.link}>
						{element.children.map(v => (
							<Menu.Item key={v.link.split("/")[1]}>
								<a href={this.state.baseUrl + this.state._id + v.link}>{v.name}</a>
							</Menu.Item>
						))}
					</Menu.SubMenu>,
				);
			} else {
				items.push(
					<Menu.Item key={element.link.split("/")[1]}>
						<a href={this.state.baseUrl + this.state._id + element.link}>{element.name}</a>
					</Menu.Item>,
				);
			}
		}
		return items;
	}

	componentDidMount() {
		const _id = this.props.location.pathname.split("/")[2];
		this.setState({_id});

		api.get(`/projects/${_id}/navigation`, Auth.createConfig())
			.then(json => this.setState({navigation: json.data.navigation, baseUrl: json.data.base_url}))
			.catch(error => console.error("Failed to fetch navigation:", error));
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.navigation !== prevState.navigation) {
			const current = this.props.location.pathname.split("/").pop();
			const openKeys = this.state.navigation
				.filter(
					el =>
						el.link.includes(current) ||
						(el.children && el.children.some(child => child.link.includes(current))),
				)
				.map(el => el.link);

			this.setState({openKeys});
		}
	}

	onOpenKeysChange = openKeys => {
		this.setState({openKeys});
	};

	toggleCollapse = () => {
		this.setState(prevState => ({collapsed: !prevState.collapsed}));
	};

	render() {
		const {collapsed} = this.state;
		const selectedMenuItem = this.props.location.pathname.split("/")[3];
		const items = this.getMenuItems();

		return (
			<Layout style={{minHeight: "100vh"}}>
				<DashboardHeader />
				<Layout>
					<Layout>
						<Layout.Sider
							width={collapsed ? 80 : "20%"}
							theme="light"
							collapsible
							collapsed={collapsed}
							trigger={null}
							className={`project-layout-sider ${collapsed ? "collapsed" : ""}`}>
							{!collapsed && (
								<Menu
									theme="light"
									mode="inline"
									selectedKeys={[selectedMenuItem]}
									onOpenChange={this.onOpenKeysChange}
									openKeys={this.state.openKeys}>
									{items}
								</Menu>
							)}
						</Layout.Sider>
						<div className="collapse-button-container">
							<Button
								type="text"
								onClick={this.toggleCollapse}
								icon={collapsed ? <RightOutlined /> : <LeftOutlined />}
								style={{width: "100%", textAlign: "center"}}
							/>
						</div>
						<Layout.Content
							style={{
								width: collapsed ? "calc(100% - 80px)" : "75%",
								backgroundColor: "rgba(162,199,226, 0.05)",
							}}>
							{this.props.children}
						</Layout.Content>
					</Layout>
				</Layout>
			</Layout>
		);
	}
}
